// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2U8ma","list":"styles_list__39f5Z"};